import templateStr from 'text!./puw-edit-vehicle.html';
import MetadataDrivenUtil from 'gw-portals-driven-ui-js/MetadataDrivenUtil';
import MetadataDrivenParser from 'gw-portals-driven-ui-js/MetadataDrivenParser';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import cssUtil from 'edge/api/gw-portals-util-js/CssUtil';
import styles from './PUWEditVehicle-hashed.scss';

export default ['MetadataDrivenUIService', (MetadataDrivenUIService) => {
    return {
        restrict: 'A',
        scope: {
            vehicle: '=',
            vehicleImageUrl: '=?',
            readonly: '='
        },
        template: cssUtil.hashTemplate(templateStr, styles),

        controller: ['$scope', 'SearchService', '$stateParams', '$q', 'VinLookupService', 'ModalService', ($scope, SearchService, $stateParams, $q, VinLookupService, ModalService) => {
            const ctrl = Object.create(BaseCtrl);
            $scope.searchRequest = {
                licensePlate: null,
                country: null,
                licensePlateSearch: null,
                licensePlateSearchErrors: null
            };
            ctrl.init = function () {
                this.searchVehicleByLicense($stateParams.searchParam, $stateParams.country);
            }
            $scope.isMultiVinResults = false;
            $scope.nextAttempt = 0;
            $scope.nextAttempts = 0;
            $scope.countryValidation = '';
            $scope.clickedLicenseSearch = false;
            $scope.searchParam = null;
            $scope.country = null;
            $scope.vehiclesL = null;
            $scope.isEmptyLicenseSearch = false;
            $scope.vehicleInfoByLicense = [];
            const d = new Date();
            d.setDate(1);
            d.setMonth(1);
            d.setFullYear(2022);
            const day = d.getDate();
            const month = d.getMonth();
            const year = d.getFullYear();
            const fixedDateES = `${day}/${month}/${year}`;
            if ($scope.vehicle.makerWarrantyKilometers.value == undefined) {
                $scope.vehicle.makerWarrantyKilometers.value = null;
            }
            VinLookupService.licenseSearchResponseFieldsCount = 0;
            VinLookupService.vinSearchResponseFieldsCount = 0;
            VinLookupService.nscNoVehicleInfo = false;
            VinLookupService.nscMoreResultFound = false;
            VinLookupService.nscValuesUpdated = false;
            $scope.vehicle.producerCodeLabel.value = window.producerCodeLabel;
            $scope.vehicle.producerCodeCountry.value = window.producerCodeCountry;
            $scope.isNscProducerCode = window.isNscProducerCode;
            const alfaRomeoModels = ["147", "159", "4CSpider", "4C", "Brera", "GiuliaQuadrifoglio", "Giulia", "Giulietta", "Mito", "StelvioQuadrifoglio", "Stelvio", "Tonale", "GT"];
            const lanciaModels = ["Ypsilon", "Voyager", "Thema", "Flavia", "Delta"];
            const dsModels = ["DS3", "DS4", "DS5", "DS7", "DS9"];
            $scope.$watch('vehicle.firstRegistrationDate.value', (nv, ov) => {
                const firstRegDate = $scope.vehicle.firstRegistrationDate.value;
                // auto-adjusts maker warranty date
                if (nv && nv !== ov) {
                    if (firstRegDate != undefined) {
                        let yearsToAdd = 2;
                        if ($scope.vehicle.producerCodeCountry.value == 'ES') {
                            if (moment(firstRegDate).isSame(fixedDateES) || moment(firstRegDate).isAfter(fixedDateES)) {
                                yearsToAdd = 3;
                            } else if (moment(firstRegDate).isBefore(fixedDateES)) {
                                yearsToAdd = 2;
                            }
                        }
                        if (firstRegDate.month == 1) {
                            var firstDate = new Date(firstRegDate.year, firstRegDate.month, firstRegDate.day);
                            var afterYearsDate = moment(firstDate).add(yearsToAdd, "y");
                            $scope.vehicle.makerWarrantyEnd.value = {
                                day: afterYearsDate.date(),
                                month: afterYearsDate.month(),
                                year: afterYearsDate.year()
                            };
                        } else {
                            $scope.vehicle.makerWarrantyEnd.value = {
                                day: firstRegDate.day,
                                month: firstRegDate.month,
                                year: firstRegDate.year + yearsToAdd
                            };
                        }
                    }
                }
            });

            $scope.enableLicenseSearch = () => {
                return VinLookupService.nscVINValidated
                    && $scope.vehicle.producerCodeCountry.value != 'DE';
            }

            $scope.validateRRDICode = () => {
                $scope.emptySellerSite = false;
                VinLookupService.nscBrandRRDI = $scope.vehicle.sellerSite.value;
                if (VinLookupService.nscBrandRRDI == undefined || VinLookupService.nscBrandRRDI == "") {
                    $scope.emptySellerSite = true;
                    return;
                }
                const results = SearchService.validateRRDICode(VinLookupService.nscBrandRRDI);
                $scope.resultPromise = results;
                $q.when(results,
                    (result) => {
                        VinLookupService.nscSellerSiteValidated = result;
                        console.log("NSC RRDI code search completed");
                    },
                    (error) => {
                        VinLookupService.nscSellerSiteValidated = false;
                        console.log("Error occurred while validating NSC RRDI Code");
                    }
                );
            }

            $scope.validateSellerSite = () => {
                return VinLookupService.nscBrandRRDI != undefined && VinLookupService.nscBrandRRDI != ""
                    && !VinLookupService.nscSellerSiteValidated;
            }

            $scope.validateSellerSitePattern = () => {
                // Defining the regular expression
                let strRegex = new RegExp(/^[A-Z|a-z|0-9]{7}$/);
                if ($scope.vehicle.sellerSite.value != undefined &&
                    $scope.vehicle.sellerSite.value != "") {
                    return strRegex.test($scope.vehicle.sellerSite.value);
                } else {
                    return false;
                }
            }

            $scope.enableRRDIButton = () => {
                return VinLookupService.nscVINValidated && $scope.isNscProducerCode
                    && $scope.validateSellerSitePattern();
            }

            //UCWAR-2028 Vehicle data to be filled in by external system
            $scope.searchVehicleByLicense = () => {
                VinLookupService.vinSearchTempData.revalidateError = false;
                VinLookupService.vinSearchTempData.emptyVinSearchData = false;
                $scope.isEmptyLicenseSearch = false;
                $scope.searchParam = $scope.vehicle.license.value;
                $scope.country = $scope.vehicle.licenseCountry.value;
                if ($scope.searchParam == undefined || $scope.searchParam == "" || $scope.country == undefined) {
                    $scope.isEmptyLicenseSearch = true;
                    return;
                }
                if ($scope.country.code != null && $scope.nextAttempts == 0) {
                    $scope.clickedLicenseSearch = true;
                    $scope.nextAttempts = 1;
                    return;
                }
                const searchResults = SearchService.searchVehicleByLicense($scope.searchParam, $scope.country.code);
                $scope.searchResultsPromise = searchResults;
                $q.when(
                    searchResults,
                    (searchResult) => {
                        $scope.vehiclesL = searchResult;
                        if ($scope.vehiclesL[0] == null || $scope.vehiclesL[0] == undefined) {
                            VinLookupService.vinSearchTempData.noResultOnLicenseSearch = true;
                            $scope.clickedLicenseSearch = false;
                        } else {
                            VinLookupService.vinSearchTempData.noResultOnLicenseSearch = false;
                        }
                        $scope.populateVehicleResultsByLicense();
                        if ($scope.vehicleInfoByLicense.length == 1) {
                            $scope.autoFillSingleVehicleData();
                        } else {
                            VinLookupService.vinSearchTempData.noResultOnLicenseSearch = true;
                            $scope.clickedLicenseSearch = false;
                            $scope.disableDefaults();
                        }
                        VinLookupService.vinSearchTempData.isLicenseSearchComplete = true;
                    },
                    (error) => {
                        VinLookupService.vinSearchTempData.noResultOnLicenseSearch = true;
                        $scope.clickedLicenseSearch = false;
                        VinLookupService.vinSearchTempData.isLicenseSearchComplete = true;
                    }
                );
            };

            $scope.enableVinFacilityWarning = () => {
                return !VinLookupService.vinSearchTempData.isVinSearchCompleted
                    && VinLookupService.vinSearchTempData.noResultOnLicenseSearch;
            }

            $scope.enableEmptyLicenseWarning = () => {
                return $scope.isEmptyLicenseSearch;
            }

            $scope.checkMultiVinResults = () => {
                return VinLookupService.vinSearchTempData.multipleVinResults && $scope.nextAttempt == 0;
            }
            $scope.autoFillSingleVehicleData = () => {
                let vehicle = $scope.vehicleInfoByLicense[0];
                let producerCodeCountry = $scope.vehicle.producerCodeCountry.value;

                if (vehicle.vin != undefined) {
                    $scope.vehicle.vin.value = vehicle.vin;
                }
                if (vehicle.make != undefined) {
                    $scope.vehicle.make.value = vehicle.make;
                }
                if (vehicle.model != undefined) {
                    if (vehicle.make == 'alfaromeo') {
                        $scope.vehicle.alpharomeoModel_PSA_Temp.value = vehicle.model;
                    } else if (vehicle.make == 'lancia') {
                        $scope.vehicle.lanciaModel_PSA_Temp.value = vehicle.model;
                    } else {
                        $scope.vehicle.model.value = vehicle.model;
                    }
                }
                //INCI12362794 | ITBOT : PB VOLTS : GVO SPAIN - PORTAL - ENERGY TYPE EMPTY BLOCKS SUBSCRIPTION
                let isEnergyExists = _.filter($scope.vehicle.typeOfEnergy.aspects.availableValues, function (e) { return e.code == vehicle.typeOfEnergy })[0];
                if (isEnergyExists) {
                    if (vehicle.typeOfEnergy != undefined) {
                        $scope.vehicle.typeOfEnergy.value = vehicle.typeOfEnergy;
                    }
                }
                //if (vehicle.typeOfEnergy != undefined) {
                //  $scope.vehicle.typeOfEnergy.value = vehicle.typeOfEnergy;
                //}
                if (vehicle.carPower != undefined &&
                    producerCodeCountry != 'IT' && producerCodeCountry != 'DE') {
                    $scope.vehicle.carPower.value = vehicle.carPower;
                }
                if (vehicle.carPowerKW != undefined && producerCodeCountry == 'DE') {
                    $scope.vehicle.carPowerKW.value = vehicle.carPowerKW;
                }
                if (vehicle.carPowerKWIT != undefined && producerCodeCountry == 'IT') {
                    $scope.vehicle.carPowerKWIT.value = vehicle.carPowerKWIT;
                }
                if (vehicle.firstRegistrationDate != undefined) {
                    $scope.vehicle.firstRegistrationDate.value = vehicle.firstRegistrationDate;
                }
                if (vehicle.vehicleSpecificities != undefined) {
                    $scope.vehicle.vehicleSpecificities = vehicle.vehicleSpecificities;
                }
                $scope.clickedLicenseSearch = false;
                $scope.disableDefaults();
                $scope.disableFields();
            }

            $scope.disableFields = () => {
                let vehicle = $scope.vehicleInfoByLicense[0];
                if (vehicle.make != null && vehicle.make != undefined) {
                    VinLookupService.disableData.make = true;
                    VinLookupService.licenseSearchResponseFieldsCount++;
                }
                if ((vehicle.model != null && vehicle.model != undefined) &&
                    ((vehicle.make == 'ds' && dsModels.includes(vehicle.model)) ||
                        (vehicle.make == 'lancia' && lanciaModels.includes(vehicle.model)) ||
                        (vehicle.make == 'alfaromeo' && alfaRomeoModels.includes(vehicle.model)) ||
                        (vehicle.make != 'ds' && vehicle.make != 'lancia' && vehicle.make != 'alfaromeo'))) {
                    VinLookupService.disableData.model = true;
                }
                if (vehicle.model != null && vehicle.model != undefined) {
                    VinLookupService.licenseSearchResponseFieldsCount++;
                }
                if (vehicle.carPower != null && vehicle.carPower != undefined) {
                    VinLookupService.disableData.carPower = true;
                    VinLookupService.licenseSearchResponseFieldsCount++;
                }
                //INCI12362794 | ITBOT : PB VOLTS : GVO SPAIN - PORTAL - ENERGY TYPE EMPTY BLOCKS SUBSCRIPTION
                let isEnergyExists = _.filter($scope.vehicle.typeOfEnergy.aspects.availableValues, function (e) { return e.code == vehicle.typeOfEnergy })[0];
                if (isEnergyExists) {
                    if (vehicle.typeOfEnergy != null && vehicle.typeOfEnergy != undefined) {
                        VinLookupService.disableData.energy = true;
                        VinLookupService.licenseSearchResponseFieldsCount++;
                    }
                }
                //if (vehicle.typeOfEnergy != null && vehicle.typeOfEnergy != undefined) {
                //  VinLookupService.disableData.energy = true;
                //VinLookupService.licenseSearchResponseFieldsCount++;
                //}
                if (vehicle.vehicleSpecificities != null && vehicle.vehicleSpecificities != undefined) {
                    VinLookupService.disableData.vehicleSpec = true;
                    VinLookupService.licenseSearchResponseFieldsCount++;
                }
                if (vehicle.firstRegistrationDate != null && vehicle.firstRegistrationDate != undefined) {
                    VinLookupService.licenseSearchResponseFieldsCount++;
                }
            }

            $scope.disableCarPowerFun = () => {
                return VinLookupService.disableData.carPower;
            }
            $scope.disableEnergyFun = () => {
                return VinLookupService.disableData.energy;
            }
            $scope.disableVehicleSpecFun = () => {
                return VinLookupService.disableData.vehicleSpec;
            }

            $scope.disableDefaults = () => {
                VinLookupService.disableData.make = false;
                VinLookupService.disableData.model = false;
                VinLookupService.disableData.energy = false;
                VinLookupService.disableData.carPower = false;
                VinLookupService.disableData.vehicleSpec = false;
                VinLookupService.licenseSearchResponseFieldsCount = 0;
            }

            $scope.populateVehicleResultsByLicense = () => {
                while ($scope.vehicleInfoByLicense.length > 0) {
                    $scope.vehicleInfoByLicense.pop();
                }
                $scope.vehiclesL.forEach((vehicle) => {
                    if (vehicle != null && ($scope.vehicle.producerCodeLabel.value != 'alfaRomeoCertified' &&
                        $scope.vehicle.producerCodeLabel.value != 'LanciaCertifed' &&
                        $scope.vehicle.producerCodeLabel.value != 'DSCertified') ||
                        (vehicle.make == 'alfaromeo' && $scope.vehicle.producerCodeLabel.value == 'alfaRomeoCertified') ||
                        (vehicle.make == 'lancia' && $scope.vehicle.producerCodeLabel.value == 'LanciaCertifed') ||
                        (vehicle.make == 'ds' && $scope.vehicle.producerCodeLabel.value == 'DSCertified')) {
                        const vehInfo = {
                            vin: '',
                            typeOfEnergy: '',
                            model: '',
                            carPower: '',
                            make: '',
                            firstRegistrationDate: '',
                            vehicleSpecificities: ''
                        };

                        vehInfo.vin = vehicle.vin
                        vehInfo.model = vehicle.model
                        vehInfo.typeOfEnergy = vehicle.typeOfEnergy
                        let producerCodeCountry = $scope.vehicle.producerCodeCountry.value;
                        if (producerCodeCountry != 'IT' && producerCodeCountry != 'DE') {
                            vehInfo.carPower = vehicle.carPower;
                        } else if (producerCodeCountry == 'DE') {
                            vehInfo.carPowerKW = vehicle.carPowerKW;
                        } else if (producerCodeCountry == 'IT') {
                            vehInfo.carPowerKWIT = vehicle.carPowerKWIT;
                        }
                        vehInfo.make = vehicle.make
                        vehInfo.firstRegistrationDate = vehicle.firstRegistrationDate
                        vehInfo.vehicleSpecificities = vehicle.vehicleSpecificities

                        $scope.vehicleInfoByLicense.push(vehInfo);
                    }
                });

                return $scope.vehicleInfoByLicense;

            }

            // UCWAR-1928 
            $scope.validateCarPower = () => {
                var enableCarPowerError = false;
                let producerCodeCountry = $scope.vehicle.producerCodeCountry.value;
                if ($scope.vehicle.producerCodeLabel.value != 'alfaRomeoCertified'
                    || ($scope.vehicle.make.value != undefined && $scope.vehicle.make.value.code != 'alfaromeo')) {
                    if (producerCodeCountry == 'FR' && $scope.vehicle.carPower.value > 510) {
                        enableCarPowerError = true;
                    }
                    if (producerCodeCountry == 'ES' && $scope.vehicle.carPower.value > 380) {
                        enableCarPowerError = true;
                    }
                    if (producerCodeCountry == 'DE' && $scope.vehicle.carPowerKW.value > 300) {
                        enableCarPowerError = true;
                    }
                    if (producerCodeCountry == 'IT' && $scope.vehicle.carPowerKWIT.value > 249) {
                        enableCarPowerError = true;
                    }
                }
                return enableCarPowerError;
            }

            $scope.getMakerWarrantyKMLength = function () {
                if ($scope.vehicle.makerWarrantyKilometers.value != null &&
                    ($scope.vehicle.makerWarrantyKilometers.value === undefined
                        || $scope.vehicle.makerWarrantyKilometers.value.toString().length > 10)) {
                    return true;
                } else {
                    return false;
                }
            };

            $scope.$watch('vehicle.makerWarrantyEnd.value', (nv, ov) => {
                // makes sure WarrantyDate [day & month] are always the same as FirstRegistrationDate [day & month]
                // NOTE: angularjs datepicker on min year view resets day & month to 01/01
                const firstRegDate = $scope.vehicle.firstRegistrationDate.value;
                const makerWarrantyEndDate = $scope.vehicle.makerWarrantyEnd.value;
                if (nv && nv !== ov && firstRegDate != undefined) {
                    $scope.$applyAsync(() => {
                        if (firstRegDate.month == 1) {
                            $scope.vehicle.makerWarrantyEnd.value = {
                                day: makerWarrantyEndDate.day,
                                month: makerWarrantyEndDate.month,
                                year: makerWarrantyEndDate.year
                            };
                        } else {
                            $scope.vehicle.makerWarrantyEnd.value = {
                                day: firstRegDate.day,
                                month: firstRegDate.month,
                                year: makerWarrantyEndDate.year
                            };
                        }
                    });
                }
            });
            //UCWPRODENG-788 Convert License Plate number to uppercase.
            $scope.$watch('vehicle.license.value', () => {
                if ($scope.vehicle.license.value != null) {
                    $scope.vehicle.license.value = $scope.vehicle.license.value.toUpperCase();
                }
            });
            function resetForm() {
                $scope.vinLoaded = true;
                $scope.isMetadataDrivenUIEnabled = MetadataDrivenUtil.isStepEnabled('puw', 'puw-vehicle-details'); // TODO

                if ($scope.isMetadataDrivenUIEnabled) {
                    $scope.loading = true;
                    MetadataDrivenUIService.getPresentationMetadata('quoteandbind-puw.{SEGMENT}.vehicleDetails').then(vehicleDetailsPresentationMetadata => {
                        vehicleDetailsPresentationMetadata = new MetadataDrivenParser(vehicleDetailsPresentationMetadata, $scope.vehicle).parsePageContent();
                        $scope.$applyAsync(() => {
                            $scope.presentationData = vehicleDetailsPresentationMetadata;
                            $scope.loading = false;
                        });
                    });
                }
            }

            resetForm();
            $scope.$on('update-form', () => {
                resetForm();
            });
            //set max length UCWPRODENG-809
            $(document).ready(function () {
                var spotiCarPurchaseOrderObj = document.querySelectorAll('[model="vehicle.spotiCarPurchaseOrder"]  input')[0];
                var purchasePriceObj = document.querySelectorAll('[model="vehicle.purchasePrice"]  input')[0];
                var sellerPriceObj = document.querySelectorAll('[model="vehicle.sellerPrice"]  input')[0];
                if (spotiCarPurchaseOrderObj) {
                    spotiCarPurchaseOrderObj.setAttribute('maxlength', "21");
                }
                if (purchasePriceObj) {
                    purchasePriceObj.setAttribute("onKeyDown", "if(this.value.length==32 && event.keyCode>47 && event.keyCode < 58)return false;");
                }
                if (sellerPriceObj) {
                    sellerPriceObj.setAttribute("onKeyDown", "if(this.value.length==32 && event.keyCode>47 && event.keyCode < 58)return false;");
                }
                var sellerSiteObj = document.querySelectorAll('[model="vehicle.sellerSite"]  input')[0];
                if (sellerSiteObj) {
                    //UCWPRODENG-838
                    sellerSiteObj.setAttribute('maxlength', "7");
                }
            });
        }]
    };
}];
